module.exports = __webpack_public_path__ + "img/13.7686b88b.jpg";